import { lazy } from 'react';

import { typedRoutes } from './utils/module-interfaces';

import { AkLogo, Ak25Logo, AkFooterLogo } from '@assets/icons/svgs';

import { PATHS } from './soft-paths/home';

export const ROUTES = typedRoutes({
    HOME: {
        ...PATHS.HOME,
        id: 'HOME',
        name: 'Home',
        // IconComponent: AkLogo,
        IconComponent: Ak25Logo,
        linkClass: 'menu-home__header-logo',
        i18nBase: 'home:module',
        i18nId: 'home:module.menu-label',
        displayInMenu: false,
        component: lazy(() => import('../components/modules/home/home')),
    },
    HOME_LOGIN: {
        ...PATHS.HOME_LOGIN,
        id: 'HOME_LOGIN',
        name: 'Home + Login',
        linkClass: 'menu-home__header-logo',
        i18nBase: 'home:module.home',
        i18nId: 'home:module.home.menu-label',
        displayInMenu: false,
        privateMode: true,
        component: lazy(() => import('../components/modules/home/home')),
    },
    FOOTER_HOME: {
        ...PATHS.FOOTER_HOME,
        id: 'FOOTER_HOME',
        name: 'Footer Home',
        IconComponent: AkFooterLogo,
        linkClass: 'menu-home__footer-logo',
        i18nBase: 'home:module.home',
        i18nId: 'home:module.home.menu-label',
        displayInMenu: false,
        component: lazy(() => import('../components/modules/home/home')),
    },
});

export const DEFAULT_ROUTE = ROUTES.HOME;
